import { node, string } from "prop-types";

import "./rich-text-page.scss";

import Page from "../Page/Page.jsx";
import Container100 from "../Container/Container100.jsx";

const propTypes = {
  content: node.isRequired,
  title: string,
};

const RichTextPage = (props) => {
  const { content, title } = props;
  return (
    <Page title={title || ""}>
      <Container100 className="rich-text-page">{content}</Container100>
    </Page>
  );
};

RichTextPage.propTypes = propTypes;
export default RichTextPage;
